import { IBuildListSorting } from "./types";
import { isString } from "../isString";
import { APIListSortingMap, ListSorting } from "@constants/types/ListSorting";

export const buildListFieldsSorting: IBuildListSorting = (
  order: ListSorting | undefined | null,
  field: string | undefined | null
): undefined | { sort_by: string; sort_dir: string } => {
  if (!order || !APIListSortingMap[order]) return undefined;

  if (!field || !isString(field)) return undefined;

  return {
    sort_by: field,
    sort_dir: APIListSortingMap[order],
  };
};
